import { render, staticRenderFns } from "./checkout-modal.vue?vue&type=template&id=3bb1c0da&"
import script from "./checkout-modal.vue?vue&type=script&lang=js&"
export * from "./checkout-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports